import Vue from 'vue';
import customHelper from '../../../helpers/custom';
import { checkPricingAccess } from '../../../helpers/pricingHelper';
import { getPreparedCustomColumnById } from './CustomColumn';
import estimationModule from '../../gantt/modules/estimation';
import timeTrackingModel from '../../../models/timeTracking';
import projectsModel from '../../../models/projects';
import globalStore from '$$store/main';
import _ from '../../../libs/lodash';
import rights from '../../../components/rights';
import chunkHelper from '../chunkHelper';

import moment from '../../../libs/moment';

let taskCrumbs = {};
let projectsName = {};
// const updateCrumbs = 1;

const update = {
  crumbs: 1,
  projectName: 1,
};

class TableTasks {
  static getPath(project_id, parent_id) {
    const subPath = parent_id ? TableTasks.getStringPathByParentId(parent_id) : '';

    let project_name = project_id ? projectsName[project_id] : '';

    if (!project_name && project_id) {
      const projectData = projectsModel.getItem(project_id);

      project_name = projectData.name;
    }

    return project_name + subPath;
  }

  static getStringPathByParentId(id) {
    let str_way = taskCrumbs[id];

    if (!str_way) {
      str_way = '';
      const tasksData = id ? globalStore.getters['tasksModel/getTask'](id) : null;

      if (tasksData && tasksData.parent && tasksData.parent !== 1) {
        str_way = TableTasks.getStringPathByParentId(tasksData.parent);
        str_way = `${str_way} / ${tasksData.text}`;
      }
    }

    taskCrumbs[id] = str_way;

    return customHelper.formatTaskName(taskCrumbs[id]);
  }

  constructor() {
    this.tasks = [];
    this.ganttIDs = [];
    this.pricingAccesToCustomColumns = checkPricingAccess('custom_fields');
  }

  init(ganttIds) {
    this.addTasksByProjectIDs(ganttIds);
  }

  updateGanttIds(ganttIDs) {
    this.ganttIDs = [...ganttIDs];
  }

  updateTaskById(taskId) {
    const task = this.tasks.find(t => t.id === taskId);
    const updTask = this._prepareTask(taskId);

    if (task && updTask) {
      const newTask = { ...task, ...updTask };
      const taskIndex = this.tasks.findIndex(t => t.id === updTask.id);

      this.tasks.splice(taskIndex, 1, newTask);

      globalStore.commit('listView/updateTask', newTask);

      return;
    }

    if (!task && updTask && this.ganttIDs.includes(updTask.gantt_id)) {
      this.addTaskById(taskId);
    }
  }

  _getNewKeys(obj_1, obj_2) {
    if (!obj_1 && !obj_2) { return []; }

    if (!obj_1) return Object.keys(obj_2);
    if (!obj_2) return Object.keys(obj_1);

    const k_2 = Object.keys(obj_2);
    const k_1 = Object.keys(obj_1);

    const noExist = k_2.filter(i => !k_1.includes(i));

    return noExist;
  }

  updateTasksByProjectId(projectId) {
    const newTasks = this._prepareTasksByProject(projectId);
    const objTasks = this._transformArrToObject(newTasks, 'id');
    const deleteIndexes = [];
    let lastIndex = this.tasks.length;

    const newKeys = this._getNewKeys(this.tasks[0], newTasks[0]);

    this.tasks.forEach((task, index) => {
      if (task.gantt_id !== projectId) { return; }

      const updTask = objTasks[task.id];

      if (!updTask) {
        deleteIndexes.push(index);

        return;
      }

      newKeys.forEach(key => {
        Vue.set(task, key, updTask[key]);
      });

      Object.assign(task, updTask);
      delete objTasks[task.id];
      lastIndex = index + 1;
    });

    const restTasks = Object.values(objTasks);

    this.tasks.splice(lastIndex, 0, ...restTasks);

    deleteIndexes.reverse().forEach(index => {
      this.tasks.splice(index, 1);
    });
  }

  addTaskById(taskId) {
    const newTask = this._prepareTask(taskId);

    if (!newTask || !this._isCanAddTask(taskId, newTask.gantt_id)) return;

    const isProjectTask = newTask.type !== 'milestone' && newTask.type !== 'task';

    if (isProjectTask) return;

    if (this.tasks.find(t => t.id === newTask.id)) {
      return;
    }

    this.tasks.push(newTask);

    const isActiveFilter = globalStore.getters['filter/isActive'];

    !isActiveFilter && globalStore.commit('listView/pushToFiltredTasks', [newTask]);

    return newTask;
  }

  _isCanAddTask(task_id, gantt_id) {
    const accessToAllTask = rights.project.hasRight(gantt_id, 'all_tasks');

    if (!accessToAllTask) {
      const projectData = globalStore.getters['tasksModel/getItem'](gantt_id);
      const assignedResources = projectData?.resourcesToTasks[task_id] || [];
      const resourceData = globalStore.getters['resourcesModel/getResourceByUserId'](user.id);

      return assignedResources.find(r => r.resource_id === resourceData.id);
    }

    return true;
  }

  async addTasksByProjectIDs(projectIDs) {
    const newTasks = [];

    projectIDs.forEach(gantt_id => {
      newTasks.push(...this._prepareTasksByProject(gantt_id));
    });

    await chunkHelper.chunkMutation(this.tasks, newTasks);

    // this.tasks.push(...newTasks);

    const isActiveFilter = globalStore.getters['filter/isActive'];

    !isActiveFilter && globalStore.commit('listView/pushToFiltredTasks', newTasks);
  }

  deleteTasksById(tasksId) {
    const tasks_ids = Array.isArray(tasksId) ? tasksId : [tasksId];
    const indexes = [];

    tasks_ids.forEach(id => {
      const index = this.tasks.findIndex(t => t.id == id);

      if (index < 0) return;

      indexes.push(index);
    });

    indexes.reverse().forEach(index => {
      this.tasks.splice(index, 1);
    });

    globalStore.commit('listView/deleteTasks', { taskIds: tasks_ids });
  }

  deleteTasksByProjectIDs(projectIDs) {
    const ganttIds = Array.isArray(projectIDs) ? projectIDs : [projectIDs];
    const indexes = [];

    this.tasks.forEach((task, index) => {
      if (ganttIds.includes(task.gantt_id)) { indexes.push(index); }
    });

    indexes.reverse().forEach(index => {
      this.tasks.splice(index, 1);
    });

    globalStore.commit('listView/deleteTasks', { projectIds: ganttIds });
  }

  _transformArrToObject(arr, property) {
    if (!arr) return {};

    const obj = {};

    arr.forEach(i => obj[i[property]] = i);

    return obj;
  }

  _prepareTask(taskId) {
    const modelTask = globalStore.getters['tasksModel/getTask'](taskId);
    const task = _.cloneDeep(modelTask);

    this._addTaskData(task);

    const customColumns = this._getCustomColumnsByProject(task.gantt_id);
    const customCol = customColumns[taskId];

    customCol && Object.assign(task, customCol);

    return task;
  }

  _prepareTasksByProject(projectId) {
    const allowedTasks = TableTasks._getTasks(projectId);

    if (!allowedTasks.length) { return []; }

    const customColumns = this._getCustomColumnsByProject(projectId);

    const preparedTasks = allowedTasks.map(modelTask => {
      let task = { ...modelTask };

      this._addTaskData(task);

      const customCols = customColumns[task.id];

      if (customCols) {
        task = Object.assign(task, customCols);
        task.customColumns = customCols;
      }

      return task;
    });

    return preparedTasks;
  }

  static _getTasks(projectId) {
    const modelTasks = globalStore.getters['tasksModel/getTasksByGanttIds']([projectId]);
    const tasks = modelTasks && modelTasks.length ? modelTasks : [];
    const _tasksWithoutProjectTask = [];

    tasks.map(t => {
      const task = { ...t };
      const isProjectTask = task.type !== 'milestone' && task.type !== 'task';

      if (!isProjectTask) {
        _tasksWithoutProjectTask.push(task);
      }
    });

    return _tasksWithoutProjectTask;
  }

  _getCustomColumnsByProject(projectId) {
    if (!this.pricingAccesToCustomColumns) { return {}; }

    const customData = globalStore.getters['columns/getProjectById'](projectId);
    const customTasks = {};
    const baseTask = {};

    customData.columns.forEach(columnId => {
      setVal(baseTask, columnId, '');
    });

    const groupTasks = globalStore.getters['tasksModel/getItem'](projectId)?.tasks;

    groupTasks.forEach(task => customTasks[task.id] = { ...baseTask });

    if (!customData.values) { return customTasks; }

    Object.keys(customData.values).forEach(task_id => {
      let taskCustomCols = customTasks[task_id];

      if (!taskCustomCols) { taskCustomCols = { ...baseTask }; }

      customData.values[task_id].forEach(col => {
        const customCol = getPreparedCustomColumnById(col.column_id);

        if (!customCol) return;

        if (customCol.isOptions) {
          const opt = customCol.data.find(i => col.task_value === i.id);

          setVal(taskCustomCols, col.column_id, opt, customCol.editor === 'multiselect');
        } else {
          taskCustomCols[col.column_id] = col.task_value ? col.task_value : '';
        }
      });

      customTasks[task_id] = taskCustomCols;
    });

    return customTasks;

    function setVal(obj, property, val, isArrayValue) {
      if ((typeof val === 'undefined') || val === null) return;

      if (!isArrayValue) {
        obj[property] = val;

        return;
      }

      const prop = obj[property];

      if (!prop) {
        obj[property] = [val];

        return;
      }

      obj[property].push(val);
    }
  }

  _addTaskData(task) {
    task.overdue = this._isOverdurTask(task);
    task.closed = task.status == 4;

    task.creator = _.find(gantt.config.columns, { name: 'creator' }).template(task);
    task.create_date = new Date(task.created_at).getTime();

    const hasCostRight = rights.project.hasCostRight(task.gantt_id);

    task.actual_cost = hasCostRight ? estimationModule.helpers.getActualCostValueForTask(task) : '';
    task.total_price = hasCostRight ? estimationModule.helpers.getPriceForTask(task) : '';

    const logsData = timeTrackingModel.getLogsByParams(task.gantt_id, task.id);

    task.time_tracking = logsData ? logsData.sum : 0;

    task.start_date = gantt.getClosestWorkTime({ date: task.start_date, dir: 'future' });
    task.end_date = gantt.calculateEndDate(task);

    task.comments = task.hasComments ? { count: task.hasComments, unread: task.newComments } : null;
    task.attachments = task.hasAttachments ? { count: task.hasAttachments, unread: false } : null;

    // project name info

    let project_name = projectsName[task.gantt_id];

    if (!project_name) {
      const projectData = projectsModel.getItem(task.gantt_id);

      project_name = projectData.name;
    }

    task.project_name = customHelper.formatTaskName(project_name);
    task.project_extra = '';
  }

  _isOverdurTask(task) {
    return moment(task.end_date).isBefore() && task.progress < 1 && task.type === 'task';
  }

  // _getStringBreadCrumbs(parentId) {
  //   const breadCrumbs = globalStore.getters['tasksModel/getDataForBreadcrumbsByParentId'](parentId);

  //   return breadCrumbs.reduce((sum, elem) => `${sum} / ${elem.text}`, '');
  // }

  updateDataProjectName() {
    projectsName = {};
    update.projectName++;
  }

  updateDataForBreadCrumbs() {
    taskCrumbs = {};
    projectsName = {};
    update.crumbs++;
  }
}

export { update };

export default TableTasks;
